import {Helper, SelectControl} from '../../app/shared/classes';
import {ComponentTypesEnum} from '../../app/shared/enums/common';

export const FileImportTypeSelector = 'fileImportType';

export const FileImportTypeControl = (): SelectControl => {
    return new SelectControl({
        name: FileImportTypeSelector,
        value: null,
        placeholder: 'Document type',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: Helper.enumsHelper().getFileImportDocumentTypes().getTypeKeys().map((key: string) => {
            return {
                label: Helper.enumsHelper().getFileImportDocumentTypes().getTypeValue(key),
                value: key
            };
        })
    });
};
